import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, cloneDeep, uniq } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import noImage from '../../../assets/images/no-image.png';
import TestingAttributes from '../../../Pages/DevlopmentOrder/Testing/TetsingAttributes/testingAttributes';
import * as action from '../../../Pages/DevlopmentOrder/store/DevelopmentOrder.action';
import { fetchCards, fetchSupplier } from '../../../Pages/DevlopmentOrder/Bom/store/BOMConfig.action';
import * as bomAction from '../../../Pages/Library/BomLibrary/store/BomLibrary.action';
import * as supportingAction from '../../SupportingDocument/store/SupportingDocument.action';
import * as productAttributeActions from '../../../Pages/DevlopmentOrder/ProductBomModal/store/product.action';
import { checkStatus, hoverTooltip, shortenandHoverString } from '../../helper';
import ProductAttributes from '../../../Pages/DevlopmentOrder/ProductBomModal/productAttributes';
import FilePreview from '../../FilePreview/FilePreview';
import { useComponent } from '../../../Pages/UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import BomSupplierCard from './BomSupplierCard';
import { getBomComponentProductRef, clearBomSupplierSuggestion } from '../../../Pages/SupplierSuggestion/store/SupplierSuggestion.action';

const forSowingTest = (tex) => {
  return tex || '-';
};

const forNoData = (tex) => {
  return tex || '';
};

const forShowingToolTip = (text) => {
  if (!text) return '';
  const trimmed = text.length > 30 ? `${text.slice(0, 30)}...` : text;
  return <span title={text}>{trimmed}</span>;
};

/**
 * Renders every component supplier on a BOM row as display text. Reads both the flat
 * BOMSupplier list and the productSupplier/componentSupplier combinations, and drops
 * blanks and duplicates so a supplier paired with several product suppliers is named once.
 * @param {object} row BOM row as returned by the card list API.
 * @param {object} viewer Viewer context: { isSupplierLoggedIn, loggedInSupplierName }.
 * @returns {string} Component supplier names separated by a comma and a space.
 */
export const formatComponentSuppliers = (row, viewer = {}) => {
  const { isSupplierLoggedIn, loggedInSupplierName } = viewer;
  const bomSuppliers = Array.isArray(row?.BOMSupplier) ? row.BOMSupplier : [row?.BOMSupplier];
  const entries = [...bomSuppliers.filter(Boolean), ...(row?.combinationSuppliers || [])];
  const names = [];
  entries.forEach((entry) => {
    if (isSupplierLoggedIn && (loggedInSupplierName === entry?.name || entry?.name === 'Locally Sourced')) {
      names.push(entry?.name);
    } else if (!isSupplierLoggedIn) {
      names.push(entry?.componentSupplier?.name || entry?.name);
    }
  });
  return uniq(names.filter(Boolean)).join(', ');
};

/**
 * Renders the product suppliers a BOM row belongs to: the supplier combinations when the
 * row has them, otherwise the product suppliers the row is assigned to.
 * @param {object} row BOM row as returned by the card list API.
 * @returns {string} Product supplier names separated by a comma and a space.
 */
export const formatProductSuppliers = (row) => {
  const names = !isEmpty(row?.combinationSuppliers)
    ? row.combinationSuppliers.map((combination) => combination?.productSupplier?.name)
    : (row?.suppliers || []).map((supplier) => supplier?.name);
  return uniq(names.filter(Boolean)).join(', ');
};

const OpenTestReq = (reqData, setTestReqData, setShowTestReq) => {
  setTestReqData(reqData);
  setShowTestReq(true);
};

const OpenProductTest = (reqData, setProductReqData, setShowProdReq) => {
  setProductReqData(reqData);
  setShowProdReq(true);
};

const openBomUsage = async (element, paramId, dispatch, setProductReqData, setShowProdReq) => {
  OpenProductTest(element, setProductReqData, setShowProdReq);
};

function BomLibraryCard({
  item,
  index,
  onCheck,
  onEdit,
  onDelete,
  editeble,
  selectedIds,
  isImport,
  handleImportLib,
  handleExpand,
  isSupplierLoggedIn,
  isProductArchived,
  selectIndex,
  devOrderId,
  fromBomLib,
  onAddBomTags,
  isFromLibrary,
  setInitialState,
}) {
  const { t } = useTranslation('common');
  const { t: tBom } = useTranslation('modules/bom');
  const dispatch = useDispatch();
  const paramId = useParams();
  const highlightedField = 'highlighted-field add-common-form';
  const reducerState = useSelector((redState) => redState);
  const { BomLibraryDetails, BOMConfigDetails, SupportingDocument, UserDetails } = reducerState;
  const { userInfo } = UserDetails;
  const companySlug = window.location.hostname?.split('.')?.[0];
  const loggedInSupplierName = userInfo?.userCompanies?.companiesList?.find((company) => company.companyName === companySlug)?.supplierName;
  const { newBomLibraryList } = BomLibraryDetails;
  const { cardList } = BOMConfigDetails;
  const { mergedUrl } = SupportingDocument;
  const [element, setElement] = useState(null);
  const [testReqData, setTestReqData] = useState(null);
  const [productReqData, setProductReqData] = useState(null);
  const [showTestReq, setShowTestReq] = useState(null);
  const [showProdReq, setShowProdReq] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [showBomSupplierModal, setShowBomSupplierModal] = useState(false);
  const [selectedBomSupplierId, setSelectedBomSupplierId] = useState(null);
  const [isSlidingButtonsOpen, setIsSlidingButtonsOpen] = useState(false);

  const ProductTestingData = useSelector((redState) => redState);
  const { Users } = ProductTestingData;
  const { logInRights } = Users;
  const { CheckActionPermission } = useComponent();
  const givenData = isFromLibrary ? 'libraries' : 'products';
  const BomAddEditAccess = CheckActionPermission(logInRights, givenData, 'bom', 'addEdit');
  const BomLibraryAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'bom', 'addEdit');
  const BomDeleteAccess = CheckActionPermission(logInRights, givenData, 'bom', 'delete');

  const isChecked = selectedIds.filter((val) => val === item._id).length > 0;

  const handleEdit = (id) => {
    onEdit(id);
  };
  const handleBomtagsModel = (id) => {
    onAddBomTags(id);
  };
  const toggleTestReq = () => {
    setShowTestReq(!showTestReq);
    dispatch(action.clearReducer());
  };
  useEffect(() => {
    const value = item ? { ...item } : null;
    if (value?.composition?.length > 0) {
      value.composition = value.composition
        .sort((a, b) => b.percentage - a.percentage)
        .map((ele) => {
          const percentagePart = ele.percentage ? `${ele.percentage}%` : '';
          const compositionPart = ele.composition?.name || '';
          return `${percentagePart} ${compositionPart}`;
        });
    }

    setElement(value);
  }, [item]);

  useEffect(() => {
    if (showProdReq && !isEmpty(cardList) && (!isEmpty(productReqData) || productReqData !== null)) {
      const tempData = cardList.filter((objEle) => objEle._id === productReqData._id);
      if (!isEmpty(tempData)) {
        const NewComposition = [];
        const newCompositions = tempData[0]?.composition;
        newCompositions?.forEach((ele) => {
          let tempobj;
          if (typeof ele !== 'string') {
            tempobj = `${ele?.percentage}%${ele?.composition?.name}`;
          } else {
            tempobj = ele;
          }
          NewComposition.push(tempobj);
        });
        tempData[0].composition = NewComposition;
        setProductReqData(tempData[0]);
      }
    }
  }, [showProdReq, cardList, productReqData]);

  useEffect(() => {
    if (showProdReq && !isEmpty(newBomLibraryList) && (!isEmpty(productReqData) || productReqData !== null)) {
      const tempData = newBomLibraryList.filter((objEle) => objEle._id === productReqData._id);
      if (Array.isArray(tempData) && !isEmpty(tempData)) {
        const NewComposition = [];
        const newCompositions = tempData[0]?.composition;
        newCompositions?.forEach((compelement) => {
          let tempobj;
          if (typeof compelement !== 'string') {
            tempobj = `${compelement?.percentage}%${compelement?.composition?.name}`;
          } else {
            tempobj = compelement;
          }
          NewComposition.push(tempobj);
        });
        tempData[0].composition = NewComposition;
        setProductReqData(tempData[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showProdReq, newBomLibraryList]);

  useEffect(() => {
    return () => {
      setElement(null);
      setTestReqData(null);
      setProductReqData(null);
      setShowTestReq(null);
      setShowProdReq(false);
      setOpenPreview(false);
      setShowBomSupplierModal(false);
      setSelectedBomSupplierId(null);
      setIsSlidingButtonsOpen(false);
      dispatch(clearBomSupplierSuggestion());
    };
  }, [dispatch]);

  const handleMergedPreview = async (ele) => {
    const params = {
      bomType: ele?.bomType?._id || ele?.bomType,
      devOrderId,
      bomId: ele?._id,
      libId: ele?.libId,
    };
    const res = await dispatch(supportingAction.getMergedDocs(params, t));
    if (res) {
      setOpenPreview(true);
    }
  };

  function extractMongooseId(str) {
    // Regular expression to match the ObjectId pattern
    const objectIdRegex = /[0-9a-fA-F]{24}/;

    // Find matches in the string
    const matches = str.match(objectIdRegex);

    // Extract the ObjectId
    return matches?.[0];
  }

  const toggleFP = async () => {
    setOpenPreview(!openPreview);

    const mongooseId = extractMongooseId(mergedUrl);
    if (mongooseId) {
      const params = {
        id: mongooseId,
        module: 'BOM-docs',
      };
      dispatch(supportingAction.deleteMergedDocs(params, t));
    }
  };

  const toggleProdReq = async () => {
    setShowProdReq(!showProdReq);
    dispatch(bomAction.emptyLibList());
    if (fromBomLib) {
      setInitialState();
      const getparams = {
        bomTypeId: paramId?.id,
        pageIndex: 1,
        pageSize: 20,
      };
      dispatch(bomAction.clearLibraryList());
      dispatch(bomAction.getBomLibraryGroup(getparams, t));
    } else {
      const get_params = {
        pageIndex: 1,
        pageSize: 20,
      };
      dispatch(action.clearReducer());
      dispatch(fetchCards(selectIndex, devOrderId, get_params));
    }
    dispatch(productAttributeActions.clearProducts());
  };

  const fetchPlacement = (element) => {
    const allPlacements = element.newPlacement.map((item) => item.name).join(', ');
    return <>{shortenandHoverString(allPlacements, 25)}</>;
  };

  const handleEditSupplier = async (ele) => {
    setSelectedBomSupplierId(ele?._id || ele);
    setShowBomSupplierModal(true);

    const document = {
      bomType: ele?.bomType?._id,
      devIds: [devOrderId],
      isToFilterBoms: true,
    };
    await dispatch(getBomComponentProductRef(document));
    await dispatch(fetchSupplier(devOrderId));
  };

  const handleCloseBomSupplierModal = () => {
    setShowBomSupplierModal(false);
    setSelectedBomSupplierId(null);
    dispatch(clearBomSupplierSuggestion());
  };

  const handleOpenSlidingButtons = () => {
    setIsSlidingButtonsOpen(true);
  };

  const handleCloseSlidingButtons = () => {
    setIsSlidingButtonsOpen(false);
  };
  return (
    <div id="accordion" className="col-lg-4 col-xlarge-3" key={index}>
      <div className="common-listing-card bom-new-card card">
        <div className="card-header padding-right-image">
          {isSupplierLoggedIn && (
            <ul className="card-header-icon bom-card-header">
              <li>
                <button type="button" className="btn p-0" onClick={() => handleEditSupplier(element)} aria-label="Edit">
                  <i className="icon-Supplier-Suggest" />
                </button>
              </li>
            </ul>
          )}
          {!isSupplierLoggedIn && !isProductArchived && (
            <>
              <ul className="card-header-icon bom-card-header">
                {(BomAddEditAccess || BomDeleteAccess) && (
                  <li>
                    <div className="common-checkbox size-sm">
                      <input
                        onChange={(e) => {
                          onCheck(e, item._id, index);
                        }}
                        name={`check_${index}`}
                        id={`check_${index}`}
                        type="checkbox"
                        checked={isChecked}
                      />
                      <label htmlFor={`check_${index}`} className="chklabel" />
                    </div>
                  </li>
                )}

                {editeble && BomAddEditAccess && (
                  <CustomTooltip placement="top" tooltipText={t('BUTTONS.EDIT')}>
                    <li>
                      <button type="button" className="btn p-0" onClick={() => handleEdit(element._id)} aria-label="Edit">
                        <i className="icon-Edit-1" />
                      </button>
                    </li>
                  </CustomTooltip>
                )}
                {isImport && BomAddEditAccess && BomLibraryAddEditAccess && (
                  <CustomTooltip placement="top" tooltipText={t('BUTTONS.ADD_UPDATE_INTO_LIBRARY')}>
                    <li>
                      <button type="button" className="btn p-0" onClick={() => handleImportLib(element._id)} aria-label="Add/Update dinto Library">
                        <i className="icon-Library-1" />
                      </button>
                    </li>
                  </CustomTooltip>
                )}
                {BomDeleteAccess && (
                  <CustomTooltip placement="top" tooltipText={t('BUTTONS.DELETE')}>
                    <li>
                      <button
                        type="button"
                        className="btn p-0"
                        aria-label="Delete"
                        onClick={() => {
                          onDelete(element._id);
                        }}
                      >
                        <i className="icon-Delete" />
                      </button>
                    </li>
                  </CustomTooltip>
                )}
              </ul>
              <button type="button" className="btn btn-more-actions p-0" onClick={handleOpenSlidingButtons} aria-label="More">
                <i className="icon-More" />
              </button>
              <div className={`sliding-buttons ${isSlidingButtonsOpen ? 'open' : ''}`}>
                <ul>
                  {(isImport || editeble) && BomAddEditAccess && (
                    <>
                      <CustomTooltip placement="top" tooltipText={t('BUTTONS.BOM_USAGE')}>
                        <li>
                          <button
                            type="button"
                            className="btn"
                            onClick={() => openBomUsage(element, paramId, dispatch, setProductReqData, setShowProdReq)}
                            aria-label="BOM Usage"
                          >
                            <i className="icon-Usage" />
                          </button>
                        </li>
                      </CustomTooltip>
                      <CustomTooltip placement="top" tooltipText={t('BUTTONS.TESTING_USAGE')}>
                        <li>
                          <button type="button" className="btn" onClick={() => OpenTestReq(element, setTestReqData, setShowTestReq)} aria-label="Testing Usage">
                            <i className="icon-Testing-1" />
                          </button>
                        </li>
                      </CustomTooltip>
                    </>
                  )}
                  <CustomTooltip placement="top" tooltipText={t('BUTTONS.MERGED_PDF')}>
                    <li>
                      <button type="button" className="btn" onClick={() => handleMergedPreview(element)} aria-label="Preview">
                        <i className="icon-Preview-Document" />
                      </button>
                    </li>
                  </CustomTooltip>

                  {BomAddEditAccess && (
                    <CustomTooltip placement="top" tooltipText={t('BUTTONS.ADD_BOM_TAG')}>
                      <li>
                        <button
                          type="button"
                          className="btn"
                          aria-label="Tags"
                          onClick={() => {
                            handleBomtagsModel(element._id);
                          }}
                        >
                          <i className="icon-Tags" />
                        </button>
                      </li>
                    </CustomTooltip>
                  )}
                </ul>
                <button type="button" className="btn btn-close-sliding ml-auto" onClick={handleCloseSlidingButtons} aria-label="Close">
                  <i className="icon-close f-22 cursor-pointer" />
                </button>
              </div>
            </>
          )}
          <div className="image-detail bom-image">
            <div className="card-image-preview" style={{ backgroundImage: `url(${element?.image || noImage})` }} />
            <span style={{ backgroundImage: `url(${element?.image || noImage})` }} className="big-image" />
          </div>
        </div>
        <div
          className="card-body"
          onClick={() => {
            if (editeble) handleExpand(item._id);
          }}
        >
          <h4 className="title link-title">
            <span className={element?.highlightedKeys?.includes('referenceCode') && highlightedField}>{forShowingToolTip(element?.referenceCode)}</span>
          </h4>
          <ul className="card-ul">
            <li>
              <strong>{t('BOM_LIBRARY_CARD.TYPE')}: </strong>
              <span className={element?.highlightedKeys?.includes('bomSubType') && highlightedField}>
                {element?.bomSubType?.name ? shortenandHoverString(element?.bomSubType?.name, 30) : ''}
              </span>
            </li>
            <li className="text-truncate">
              <strong>{t('BOM_LIBRARY_CARD.DESCRIPTION')}: </strong>
              <span className={element?.highlightedKeys?.includes('bomDescription') && highlightedField}>
                {shortenandHoverString(element?.bomDescription, 30)}
              </span>
            </li>

            {devOrderId && (
              <li>
                <strong>{tBom('PRODUCT_SUPPLIER')}: </strong>
                <span>{formatProductSuppliers(element) || '-'}</span>
              </li>
            )}
            <li>
              <strong>{t('BOM_LIBRARY_CARD.COMPONENT_SUPPLIER')}: </strong>
              <span className={element?.highlightedKeys?.includes('BOMSupplier') && highlightedField}>
                {formatComponentSuppliers(element, { isSupplierLoggedIn, loggedInSupplierName })}
              </span>
            </li>
            <li>
              <strong>{t('BOM_LIBRARY_CARD.PLACEMENT')}: </strong>
              <span className={element?.highlightedKeys?.includes('newPlacement') ? highlightedField : ''}>
                {Array.isArray(element?.newPlacement) && element.newPlacement.length > 0 ? fetchPlacement(element) : '-'}
              </span>
            </li>

            <li>
              <div className="d-flex flex-row">
                <div className="w-250px same-line-card">
                  <span className="composition-text">
                    <strong>{t('BOM_LIBRARY_CARD.COMPOSITION')}: </strong>
                    <span className={element?.highlightedKeys?.includes('composition') ? `${highlightedField} ` : ''}>
                      {!isEmpty(element?.composition) ? hoverTooltip(element?.composition?.join(', ')) : '-'}
                    </span>
                  </span>
                </div>
                <div className=" mx-2 w-20">
                  <h6>|</h6>
                </div>
                <div className="w-150px">
                  <strong>{t('BOM_LIBRARY_CARD.WEIGHT')}: </strong>
                  <span className={element?.highlightedKeys?.includes('weight') && highlightedField}>
                    {`${forSowingTest(element?.weight)} ${forNoData(element?.weightUnitOfMeasure?.name)}`}
                  </span>
                </div>
              </div>
            </li>
            <li>
              <div className="d-flex flex-row">
                <div className="w-50">
                  <strong>{t('BOM_LIBRARY_CARD.SIZE')}: </strong>
                  <span className={element?.highlightedKeys?.includes('size') && highlightedField}>
                    {`${forSowingTest(element?.size)} ${forNoData(element?.sizeUnitOfMeasure?.name)}`}
                  </span>
                </div>
                <div className=" mx-2 w-20">
                  <h6>|</h6>
                </div>
                <div className="w-50">
                  <strong>{t('BOM_LIBRARY_CARD.QUANTITY')}: </strong>
                  <span className={element?.highlightedKeys?.includes('quantity') && highlightedField}>
                    {`${forSowingTest(element?.quantity)} ${forNoData(element?.quantityUnitOfMeasure?.name)}`}
                  </span>
                </div>
              </div>
            </li>
            <li>
              <div className="d-flex flex-row">
                <div className="w-50">
                  <strong>{t('BOM_LIBRARY_CARD.PRICE_PER_UNIT')}: </strong>
                  <span className={element?.highlightedKeys?.includes('pricePerUnit') && highlightedField}>
                    {`${forSowingTest(element?.pricePerUnit)} ${forNoData(element?.pricePerUnitCurrency)}`}
                  </span>
                </div>
              </div>
            </li>
            <li>
              <strong>{t('BOM_LIBRARY_CARD.FINISH')}: </strong>
              <span className={element?.highlightedKeys?.includes('finished') && highlightedField}>{`${forSowingTest(element?.finished?.name)}`}</span>
            </li>
            <li className="text-truncate">
              <strong>{t('BOM_LIBRARY_CARD.ADDITIONAL_INFO')}: </strong>
              <span className={element?.highlightedKeys?.includes('additionalInfo') ? 'highlighted-field ' : ''}>
                {shortenandHoverString(element?.additionalInfo, 30, 'auto')}
              </span>
            </li>
          </ul>
        </div>
        {isImport && <div className={`status ${checkStatus(element)}`} />}
      </div>
      {showTestReq && <TestingAttributes onOpen={showTestReq} toggleTestReq={toggleTestReq} showData={testReqData} fromTestingLib={!isImport} fromProductBom />}
      {showProdReq && <ProductAttributes onOpen={showProdReq} toggleProdReq={toggleProdReq} showDatas={cloneDeep(productReqData)} fromBomLib={!isImport} />}
      {openPreview && <FilePreview onOpen={openPreview} fileObj={{ path: mergedUrl }} toggle={toggleFP} />}
      {showBomSupplierModal && (
        <BomSupplierCard show={showBomSupplierModal} onHide={handleCloseBomSupplierModal} selectedBomSupplier={selectedBomSupplierId} devOrderId={devOrderId} />
      )}
    </div>
  );
}

export default BomLibraryCard;
